import http from 'utils/http';

const calculateSubsidy = payload =>
  http.post('/voucher/v1/voucher/calculate-discount', payload);

const consume = payload => http.post('/voucher/v1/voucher/consume', payload);

const availableTeamVoucher = () =>
  http.get('/voucher/v1/voucher/available-team-voucher');

const getVoucherBalance = () => http.get('/voucher/v1/balance');

const findVoucherByCode = code =>
  http.get(`/voucher/v1/voucher/link/findMasterVoucherByCode/${code}`);

const createLinkVoucher = code =>
  http.post(`/voucher/v1/voucher/link/createVoucherByMasterCode/${code}`);

export default {
  calculateSubsidy,
  consume,
  availableTeamVoucher,
  findVoucherByCode,
  createLinkVoucher,
  getVoucherBalance,
};



// WEBPACK FOOTER //
// ./src/services/voucherService.js